/**
 * B616 leg 3b — the "Become an Insider" band above the site foot (built from
 * the board line; B614's poster wall draws it at its foot — redline pending).
 * A composition of package primitives: one email field and JOIN. The refusal
 * arrives on the press, at the field; joined, the field gives way to the
 * thanks, said as a status so a screen reader hears it.
 */
import type { ReactElement } from "react";
import { Button, Input } from "@transact/ui";
import { INSIDER_JOINED, INSIDER_PITCH, INSIDER_PITCH_SHORT, INSIDER_TITLE } from "../lib/insider.js";

export function InsiderBand(props: {
  readonly email: string;
  readonly onEmail: (value: string) => void;
  readonly onJoin: () => void;
  readonly phase: "idle" | "busy" | "joined";
  readonly error?: string | undefined;
}): ReactElement {
  return (
    <section
      className="insider"
      data-redline="storefront-insider"
      aria-labelledby="insider-title"
      aria-busy={props.phase === "busy" || undefined}
    >
      <div className="insider-words">
        {/* B653 (b) — 553:2's accent kicker is the card's heading */}
        <h2 id="insider-title" className="insider-kicker">{INSIDER_TITLE}</h2>
        {/* the 1440 pitch and the 390 one (555:130); the stylesheet shows one per width */}
        <p className="insider-pitch insider-pitch--long">{INSIDER_PITCH}</p>
        <p className="insider-pitch insider-pitch--short">{INSIDER_PITCH_SHORT}</p>
      </div>
      {props.phase === "joined" ? (
        <p className="insider-joined" role="status">
          {INSIDER_JOINED}
        </p>
      ) : (
        /* B683 (R14) — a form, so Enter in the field clicks SIGN ME UP (its submit button): the press's own refusal still lands at the field. */
        <form className="insider-form" aria-label="Become an Insider" onSubmit={(e) => e.preventDefault()}>
          <Input
            id="insider-email"
            label="Your email"
            labelHidden
            type="email"
            value={props.email}
            placeholder="you@email.com"
            onChange={props.onEmail}
            error={props.error}
          />
          <Button type="submit" onClick={props.onJoin} busy={props.phase === "busy"}>
            <span className="insider-cta--long">Sign me up</span>
            <span className="insider-cta--short">Sign up</span>
          </Button>
        </form>
      )}
    </section>
  );
}
